module.exports = __webpack_public_path__ + "img/cardBck.7ba9d04.png";